module.exports = {
  "country": "CY",
  "artist": "One",
  "song": "Gimme",
  "year": "2002",
  "place": "6",
  "spotify": "05fPDDX03OOKO4l9HCGkQw"
};